import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import gsap from 'gsap';
import { playSplitText, hideSplitText } from '../common/help_functions';
import ScrollToPlugin from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);

const currentNum = document.querySelector('.hero-slider-current-num .hero-slider-num-wrapp');
const nextNum = document.querySelector('.hero-slider-next-num .hero-slider-num-wrapp');
const progressBar = document.querySelector('.hero-slider-bar .line');
const time = 5000,
    speed = 2000;
let heroBGSwiper;


function initHeroSlider() {


    const heroContentSwiper = new Swiper('.hero-content-slider', {
        speed: 300,
        allowTouchMove: false,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },

        on: {
            slideChange: function (swiper) {
                const activeSlide = swiper.slides[swiper.realIndex];
                const activeTitle = activeSlide.querySelector('.hero-title');
                const activeText = activeSlide.querySelector('.hero-p .fade-content');
                const activeLink = activeSlide.querySelector('.hero-btn');

                const allSlides = swiper.slides;

                allSlides.forEach(slide => {
                    const prevTitle = slide.querySelector('.hero-title');
                    const prevText = slide.querySelector('.hero-p .fade-content');
                    const prevLink = slide.querySelector('.hero-btn');

                    gsap.timeline()
                        .add(hideSplitText(prevTitle))
                        .to(prevText, {
                            opacity: 0,
                            rotateX: 30,
                            y: 70,
                            ease: 'power3.inOut',
                            duration: 0.5,
                        }, '<0.2')
                        .to(prevLink, {
                            // pointerEvents: 'none',
                            duration: 0,
                        }, '<')
                        .add(() => {
                            prevLink.classList.remove('show')
                        }, '<')
                });


                gsap.timeline()
                    .add(playSplitText(activeTitle))
                    .to(activeText, {
                        opacity: 1,
                        rotateX: 0,
                        y: 0,
                        stagger: 0.1,
                        ease: 'power3.inOut',
                        duration: 2,
                    }, '<0.3')
                    .add(() => {
                        activeLink.classList.add('show')
                    }, '<0.5')
                    .to(activeLink, {
                        // pointerEvents: 'all'
                    }, '>1')
            }
        }
    })

    const heroMiniSwiper = new Swiper('.hero-slider-wrapp', {
        width: getComputedStyle(document.querySelector('.hero-slider-wrapp')).getPropertyValue('--sliderWidth').replace('px', ''),
        speed: speed,
        allowTouchMove: false,
        initialSlide: 1,
        enabled: false,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },

        on: {
            init: function () {
                if (this.slides.length <= 1) {
                    // remove .hero-slider-wrapp when 1 slide or less
                    this.el.classList.add('remove-slider-wrapp');
                }
            },
            click: function (swiper) {
                const slideIndex = heroBGSwiper.realIndex;
                const lastSlide = heroBGSwiper.slides.length - 1;

                if (!heroBGSwiper.enabled) {
                    heroBGSwiper.enable()
                    // heroBGSwiper.slideTo(0)
                }

                (slideIndex != lastSlide) ? heroBGSwiper.slideNext() : heroBGSwiper.slideTo(0);
            }
        },

    });

    if (window.innerWidth > 600) {
        heroMiniSwiper.enable();
    }


    heroBGSwiper = new Swiper('.hero-bg-slider', {
        enabled: false,
        autoplay: {
            delay: time,
            disableOnInteraction: false
        },
        pagination: {
            el: '.hero-slider-dots',
            type: 'bullets',
            bulletActiveClass: 'active',
            bulletClass: 'hero-slider-dot',
            clickable: true
        },
        speed: speed,
        allowTouchMove: false,
        initialSlide: 0,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },

        on: {
            slideChange: function (swiper) {
                const slideIndex = swiper.realIndex;
                const lastSlide = swiper.slides.length - 1;
                const numHeight = document.querySelector('.hero-slider-num li').getBoundingClientRect().height;

                (slideIndex == lastSlide) ? heroMiniSwiper.slideTo(0) : heroMiniSwiper.slideTo(slideIndex + 1);
                heroContentSwiper.slideTo(slideIndex);

                if (heroMiniSwiper.enabled) {
                    gsap.to(currentNum, {
                        y: (slideIndex) * -numHeight
                    })
                    gsap.to(nextNum, {
                        y: (slideIndex == lastSlide) ? 0 : (slideIndex + 1) * -numHeight
                    })
                    gsap.fromTo(progressBar, {
                        scaleY: 0
                    }, {
                        scaleY: 100 + '%',
                        ease: 'none',
                        duration: (time + speed) / 1000
                    })
                }

            }
        },
    });
}

export function initScrollMoreButton() {
    const buttons = document.querySelectorAll('.scroll-down');
    buttons.forEach(btn => {
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            const nextSectionTop = btn.closest('section').nextElementSibling.offsetTop;

            gsap.to(window, {
                duration: 1.2,
                scrollTo: {
                    y: nextSectionTop,
                    offsetY: 65
                }
            });
        })
    });
}

export function initHomeHeroSection() {
    initHeroSlider();

    gsap.timeline()
        .add(playSplitText('.swiper-slide-active .split'))

        .to(`.swiper-slide-active .hero-p .fade-content`, {
            opacity: 1,
            rotateX: 0,
            y: 0,
            stagger: 0.1,
            ease: 'power3.inOut',
            duration: 2,
        }, '<0.3')

        .add(() => {
            document.querySelector('.swiper-slide-active .hero-btn').classList.add('show')
        }, '<0.7')

        .to('.hero-slider-slides', {
            y: 0,
            duration: 1.5,
            ease: 'power3.inOut'
        }, '<')

        .to('.hero-slider-dots .hero-slider-dot', {
            opacity: 1,
            x: 0,
            scale: 1,
            stagger: 0.05,
            duration: 0.3
        }, '<0.9')

        .to('.hero-slider-current-num .hero-slider-num-wrapp', {
            y: 0,
            duration: 0.5,
            ease: 'power3.inOut'
        }, '<')

        .to('.hero-slider-next-num .hero-slider-num-wrapp', {
            y: -getComputedStyle(document.querySelector('.hero-slider-wrapp')).getPropertyValue('--numHeight').replace('px', ''),
            duration: 0.5,
            ease: 'power3.inOut'
        }, '<0.2')

        .fromTo(progressBar, {
            scaleY: 0
        }, {
            scaleY: 100 + '%',
            ease: 'none',
            duration: (time) / 1000
        }, '<')

        .add(() => {
            if (!heroBGSwiper.enabled) {
                heroBGSwiper.enable()
                heroBGSwiper.slideTo(1)
            }
        }, `>`)

}
